import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBox2AltFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBox2AltFill"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3L3.00006 3.00001L3 21H21V3ZM5.00003 12L5.00005 5.00001L19 5V12L15 12L15 12.0118C14.9936 13.6633 13.6529 15 12 15C10.3431 15 9 13.6569 9 12L5.00003 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBox2AltFill;
